const CYRILLIC_TO_LATIN = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  ё: 'yo',
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'y',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'kh',
  ц: 'ts',
  ч: 'ch',
  ш: 'sh',
  щ: 'shch',
  ъ: '',
  ы: 'y',
  ь: '',
  э: 'e',
  ю: 'yu',
  я: 'ya'
}

export const transliterateToLatin = (value) =>
  Array.from(String(value || '').toLowerCase())
    .map((char) => CYRILLIC_TO_LATIN[char] ?? char)
    .join('')

export const normalizeSearchText = (value) =>
  transliterateToLatin(value).replace(/\s+/g, ' ').trim()

export const matchesSearchQuery = (haystack, needle) => {
  const query = normalizeSearchText(needle)
  if (!query) return true
  return normalizeSearchText(haystack).includes(query)
}
